import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import { storeConfig } from "./config";

const EXPORT_STORAGE_KEY = "export_progress";

const createExportStore = (set, get) => ({
  exports: [], // Array of { exportId, status, employeeIds, years, filename, createdAt }

  addExport: (exportData) =>
    set((state) => {
      // Avoid duplicate entries for same exportId
      const filtered = state.exports.filter(
        (exp) => exp.exportId !== exportData.exportId
      );
      const newExports = [...filtered, exportData];
      return { exports: newExports };
    }),

  updateExport: (exportId, updates) =>
    set((state) => ({
      exports: state.exports.map((exp) =>
        exp.exportId === exportId ? { ...exp, ...updates } : exp
      ),
    })),

  removeExport: (exportId) =>
    set((state) => ({
      exports: state.exports.filter((exp) => exp.exportId !== exportId),
    })),

  getExport: (exportId) => {
    const state = get();
    return state.exports.find((exp) => exp.exportId === exportId);
  },

  clearCompleted: () =>
    set((state) => ({
      exports: state.exports.filter(
        (exp) => exp.status !== "completed" && exp.status !== "failed"
      ),
    })),
});

const persistConfig = {
  name: EXPORT_STORAGE_KEY,
  storage: createJSONStorage(() => localStorage),
};

export const useExportStore = create(
  storeConfig.devtools
    ? devtools(
        persist(createExportStore, persistConfig),
        { name: "ExportStore" }
      )
    : persist(createExportStore, persistConfig)
);

